/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Box from 'core/ui/Box';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { channelMembersActions } from 'modules/channelMembers';
import { ButtonPrimarySm } from 'core/ui/Button';
import { Link } from '@material-ui/core';
import Typography, { fontStyle } from 'core/ui/Typography';
import LoaderSm from 'core/ui/LoaderSm';
import notifications from 'modules/notifications';
import Modules from 'modules';
import useActions from 'modules/map/useActions';
import useSelectors from 'modules/map/useSelectors';
import { newChannelMembersModule } from 'modules/channelMembers/new';
import SelectFile from './SelectFile';

export default ({ channelId, close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { request } = useActions();
  const [data, setData] = useState(null);
  const ladingUploadMembers = useSelectors(newChannelMembersModule, 'loadingUpload');
  const uploadMembers = () => {
    if (channelId) {
      const formData = new FormData();
      formData.append('file', data);

      request({
        action: Modules.newChannelMembers.actions.uploadMembers,
        data: { channelId, formData },
        options: {
          onSuccess: () => {
            setData(null);
            dispatch(notifications.success(t('channel.members.uploadMembers.success')));
            dispatch(channelMembersActions.getChannelMembersStart({ channelId }));
            close();
          },
          onError: (error) => {
            dispatch(notifications.error(error));
          },
        },
      });
    }
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column" p={5}>
      <Box>
        <SelectFile setFile={setData} file={data} />
        <Typography mt={1} style={fontStyle.small} align="center">
          <Link href="/example_file_users.csv">Download Template</Link>
        </Typography>
      </Box>
      <Box my={1}>
        <ButtonPrimarySm disabled={ladingUploadMembers} p={1} onClick={() => uploadMembers()}>
          <LoaderSm loading={ladingUploadMembers} width={25} />
          {t('button.uploadMembers')}
        </ButtonPrimarySm>
      </Box>
    </Box>
  );
};
